import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DueDiligenceService } from '../../services/due-diligence/due-diligence.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-due-diligence-delete-dialog',
  templateUrl: './due-diligence-delete-dialog.component.html',
  styleUrls: ['./due-diligence-delete-dialog.component.css']
})

export class DueDiligenceDeleteDialogComponent implements OnInit {
  logFormData: any;
  agentId: any;
  loginId: any;
  DocTypeErrMsg;
  DocTypeErr:boolean = false;
  errMsg;
  errFlag: boolean = false;
  vendorName;
  firstName;
  lastName;
  constructor(private googleAnalyticsService: GoogleAnalyticsService, private changelogservice: ChangeLogService, private dueDiligenceService: DueDiligenceService, public dialogRef: MatDialogRef<DueDiligenceDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public agentData: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.DocTypeErr = false;
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }

  deleteDocument() {
    this.logFormData = {
      "document_type": this.agentData.DocumentTypeName,
      "document_category": this.agentData.DocumentCategory,
      "transaction_type": "Delete",
      "vendor_id": this.agentId
    }
  
    this.dueDiligenceService.deleteDueDocuments(this.agentData._id, this.agentId).subscribe(res => {
      this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.agentData.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
      this.dueDiligenceService.load.next('success');
      this.onNoClick();
      this.logFormData.modified_by = this.loginId;
      this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => { this.errMsg = err;
        this.errFlag = true;
      });
    }, error => {
      this.DocTypeErrMsg = 'Due Diligence Service' + ' ' + error;
      this.DocTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/due-diligence-delete-dialog/due-diligence-delete-dialog.component.ts